/**
 * Weekly-digest shared helpers — delta formatting, sign, and CSS class.
 *
 * Extracted from WeeklyView.vue (bead lucky-war-sgce.2).
 * Used by components under web/src/components/weekly/.
 */

/**
 * Format a delta value for display (absolute, 1 decimal).
 * null/undefined → '' (empty string — callers guard on existence).
 */
export function fmtDelta(d: number | null | undefined): string {
  if (d == null) return '';
  return Math.abs(d).toFixed(1);
}

/**
 * Direction sign (↑/↓/→).
 */
export function deltaSign(d: number): string {
  if (d > 0) return '↑';
  if (d < 0) return '↓';
  return '→';
}

/**
 * CSS class suffix for delta styling based on metric direction semantics.
 *
 * Returns a class name built from the given prefix (the component's BEM block):
 *   prefix + '--good' | prefix + '--bad' | ''
 *
 * - 'rating' / 'review': increase → good (green), decrease → bad (red)
 * - 'negative': increase → bad (red), decrease → good (green)
 *
 * @param d   The delta number (direction determined by sign)
 * @param metric  Semantic domain: 'rating', 'review', or 'negative'
 * @param prefix  Component-scoped class prefix (e.g. 'wkr__delta', 'wrt__delta-inline')
 */
export function deltaClass(
  d: number,
  metric: 'rating' | 'review' | 'negative',
  prefix: string,
): string {
  if (metric === 'negative') {
    if (d < 0) return `${prefix}--good`;
    if (d > 0) return `${prefix}--bad`;
  } else {
    if (d > 0) return `${prefix}--good`;
    if (d < 0) return `${prefix}--bad`;
  }
  return '';
}
